import { createBrowserHistory } from "history";

// The entities-hall MFE listens to this instance, not React Router. A router
// navigate alone leaves it on the previous page until it reloads.
export const myCropwiseHistory = createBrowserHistory();

export const getMyCropwiseLocation = (): typeof myCropwiseHistory.location =>
  myCropwiseHistory.location;

export const subscribeMyCropwiseHistory = (notify: () => void): (() => void) =>
  myCropwiseHistory.listen(notify);

export const refreshMyCropwiseHistory = (): void => {
  const { pathname, search, hash } = window.location;
  if (
    historyPath() !== `${pathname}${search}${hash}` ||
    myCropwiseHistory.location.key !== (window.history.state?.key ?? "default")
  ) {
    window.dispatchEvent(
      new PopStateEvent("popstate", { state: window.history.state })
    );
  }
};

export const scrollPageToTop = (): void => {
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  // jsdom's scrollTo only reports that it is not implemented.
  if (navigator.userAgent.includes("jsdom")) {
    return;
  }
  window.scrollTo(0, 0);
};

const historyPath = (): string => {
  const { pathname, search, hash } = myCropwiseHistory.location;
  return `${pathname}${search}${hash}`;
};

// Push when the shortcut is clicked so the MFE treats it as navigation.
// Replace when the URL is already correct and only this instance is stale,
// which must not add another browser history entry.
// Returns whether window history was changed, so the caller can avoid a
// second entry.
export const syncMyCropwiseHistory = (
  path: string,
  method: "push" | "replace" = "push"
): boolean => {
  if (!path || historyPath() === path) {
    return false;
  }
  myCropwiseHistory[method](path, { stopRedirect: true });
  return true;
};
